import { useState, type InputHTMLAttributes } from "react";
import { messages } from "../i18n/index.ts";

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

/** Şifre alanı + göster/gizle düğmesi. Telefonda yazım hatasını görmeyi kolaylaştırır. */
export function PasswordInput({ className, ...inputProps }: PasswordInputProps) {
  const [visible, setVisible] = useState(false);
  return (
    <span className="password-input">
      <input {...inputProps} type={visible ? "text" : "password"} className={className} />
      <button
        type="button"
        className="password-input__toggle"
        onClick={() => setVisible((current) => !current)}
        aria-pressed={visible}
        aria-label={visible ? messages.common.hidePassword : messages.common.showPassword}
        disabled={inputProps.disabled}
      >
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <path
            d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2" />
          {visible && <path d="M4 4l16 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />}
        </svg>
      </button>
    </span>
  );
}
